import script from "./LuckyNumbersSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./LuckyNumbersSection.vue?vue&type=script&setup=true&lang=ts"

import "./LuckyNumbersSection.vue?vue&type=style&index=0&id=f3cdb5a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3cdb5a0"]])

export default __exports__